<template>
  <van-tab :title="title">
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      class="bgwhite"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <order-panel
        v-for="(item, index) in list"
        :key="index"
        :order="item"
      />
    </van-list>
  </van-tab>
</template>

<script>
import { Icon, Tab, List } from 'vant'
import OrderPanel from './OrderPanel'
import { orderList } from '@/api/order'

export default {
  name: 'OrderTab',
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [List.name]: List,
    OrderPanel
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      keyword: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        status: undefined,
        page: 0,
        size: 8
      }
    }
  },
  created () {
    this.listQuery.status = this.status
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await orderList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
</style>
